import { render, staticRenderFns } from "./FUmkmObjectFileTable.vue?vue&type=template&id=240e2b9e"
import script from "./FUmkmObjectFileTable.vue?vue&type=script&lang=js"
export * from "./FUmkmObjectFileTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports